const setNebraskaEndpoint = (ENDPOINT_NEBRASKA) => ({ ENDPOINT_NEBRASKA });
const discoveryGateway = (GATEWAY) => ({ GATEWAY });
const discoverySzukajacySzymonApi = (SZUKAJACY_SZYMON) => ({
  SZUKAJACY_SZYMON,
});
const discoverySeoSebaApi = (SEOSEBA) => ({ SEOSEBA });
const discoveryThorondorApi = (THORONDOR) => ({ THORONDOR });
const discoveryCodziennyCzarekApi = (CODZIENNY_CZAREK) => ({
  CODZIENNY_CZAREK,
});
const discoveryCaliforniaApi = (CALIFORNIA) => ({ CALIFORNIA });
const discoveryFirmowyFilipApi = (FIRMOWY_FILIP) => ({ FIRMOWY_FILIP });
const discoveryOffersApi = (OFFERS) => ({ OFFERS });
const discoveryRecommendationsApi = (RECOMMENDATIONS) => ({ RECOMMENDATIONS });
const internalAccountsApi = (ACCOUNTS) => ({ ACCOUNTS });

module.exports = ({
  ENDPOINT_NEBRASKA,
  API_CONSUL_GATEWAY,
  API_CONSUL_SZUKAJACY_SZYMON,
  API_CONSUL_SEOSEBA,
  API_CONSUL_THORONDOR,
  API_CONSUL_CODZIENNY_CZAREK,
  API_CONSUL_CALIFORNIA,
  API_CONSUL_FIRMOWY_FILIP,
  API_CONSUL_OFFERS,
  API_CONSUL_RECOMMENDATIONS,
  API_INTERNAL_ACCOUNTS,
}) => ({
  ...setNebraskaEndpoint(ENDPOINT_NEBRASKA),
  ...discoveryGateway(API_CONSUL_GATEWAY),
  ...discoverySzukajacySzymonApi(API_CONSUL_SZUKAJACY_SZYMON),
  ...discoverySeoSebaApi(API_CONSUL_SEOSEBA),
  ...discoveryThorondorApi(API_CONSUL_THORONDOR),
  ...discoveryCodziennyCzarekApi(API_CONSUL_CODZIENNY_CZAREK),
  ...discoveryCaliforniaApi(API_CONSUL_CALIFORNIA),
  ...discoveryFirmowyFilipApi(API_CONSUL_FIRMOWY_FILIP),
  ...discoveryOffersApi(API_CONSUL_OFFERS),
  ...discoveryRecommendationsApi(API_CONSUL_RECOMMENDATIONS),
  ...internalAccountsApi(API_INTERNAL_ACCOUNTS),
});
